'use strict';

var SecuritySchemeOasAuthType = /*#__PURE__*/function (SecuritySchemeOasAuthType) {
  SecuritySchemeOasAuthType["API_KEY"] = "apiKey";
  SecuritySchemeOasAuthType["HTTP"] = "http";
  SecuritySchemeOasAuthType["MUTUAL_TLS"] = "mutualTLS";
  SecuritySchemeOasAuthType["OAUTH2"] = "oauth2";
  SecuritySchemeOasAuthType["OPEN_ID_CONNECT"] = "openIdConnect";
  return SecuritySchemeOasAuthType;
}({});
var SecuritySchemeHttpScheme = /*#__PURE__*/function (SecuritySchemeHttpScheme) {
  SecuritySchemeHttpScheme["BEARER"] = "bearer";
  SecuritySchemeHttpScheme["BASIC"] = "basic";
  SecuritySchemeHttpScheme["DIGEST"] = "digest";
  SecuritySchemeHttpScheme["OAUTH"] = "oauth";
  SecuritySchemeHttpScheme["NEGOTIATE"] = "negotiate";
  return SecuritySchemeHttpScheme;
}({});
var SecuritySchemeBearerFormat = /*#__PURE__*/function (SecuritySchemeBearerFormat) {
  SecuritySchemeBearerFormat["JWT"] = "JWT";
  return SecuritySchemeBearerFormat;
}({});
var SecurityParamterLocation = /*#__PURE__*/function (SecurityParamterLocation) {
  SecurityParamterLocation["QUERY"] = "query";
  SecurityParamterLocation["HEADER"] = "header"; // 暂不支持 Cookie
  // COOKIE = 'cookie',
  return SecurityParamterLocation;
}({});
var SecurityParamterLocationOptions = [{
  label: 'Query',
  value: SecurityParamterLocation.QUERY
}, {
  label: 'Header',
  value: SecurityParamterLocation.HEADER
}
// {
//   label: 'Cookie',
//   value: SecurityParamterLocation.COOKIE,
// },
];
var JwtAddTokenToOptions = [{
  label: 'Query',
  value: SecurityParamterLocation.QUERY
}, {
  label: 'Header',
  value: SecurityParamterLocation.HEADER
}];
var SecuritySchemeAuthType = /*#__PURE__*/function (SecuritySchemeAuthType) {
  SecuritySchemeAuthType["APIKEY"] = "apikey";
  SecuritySchemeAuthType["BEARER"] = "bearer";
  SecuritySchemeAuthType["JWT"] = "jwt";
  SecuritySchemeAuthType["BASIC"] = "basic";
  SecuritySchemeAuthType["DIGEST"] = "digest";
  SecuritySchemeAuthType["OAUTH2"] = "oauth2";
  SecuritySchemeAuthType["OAUTH1"] = "oauth1";
  SecuritySchemeAuthType["HAWK"] = "hawk";
  SecuritySchemeAuthType["AWSV4"] = "awsv4";
  SecuritySchemeAuthType["KERBEROS1"] = "kerberos1";
  SecuritySchemeAuthType["NTLM"] = "ntlm";
  SecuritySchemeAuthType["EDGEGRID"] = "edgegrid";
  SecuritySchemeAuthType["CUSTOMIZE"] = "customize";
  SecuritySchemeAuthType["COMBINATION"] = "combination";
  return SecuritySchemeAuthType;
}({});
exports.JwtAddTokenToOptions = JwtAddTokenToOptions;
exports.SecurityParamterLocation = SecurityParamterLocation;
exports.SecurityParamterLocationOptions = SecurityParamterLocationOptions;
exports.SecuritySchemeAuthType = SecuritySchemeAuthType;
exports.SecuritySchemeBearerFormat = SecuritySchemeBearerFormat;
exports.SecuritySchemeHttpScheme = SecuritySchemeHttpScheme;
exports.SecuritySchemeOasAuthType = SecuritySchemeOasAuthType;
